import * as PIXI from 'pixi.js';
import Text from './Text';
import { NONE } from '../constants/DropShadow';

/**
 * TextLine opens up the ability to animate each individual word in a line of text.
 *
 * By default, the appearance of TextLine will be the same as regular PIXI.Text given the same style and text.
 */
export default class TextLine extends PIXI.Container {
  text = '';
  words = [];
  texts = [];
  textPositions = [];
  lineHeight = 0;

  constructor(app) {
    super();

    this.app = app;
  }

  /**
   * Update text and style for the text line, position words
   */
  updateTextAndStyle(text, model, options = {}) {
    if (this.texts.length) {
      this.removeChild(...this.texts);
    }

    // This element helps us get accurate text measurements for initial word positions
    const positionHelperText = new Text(this.app);
    positionHelperText.updateStyle({ ...model, dropShadow: NONE }, options);

    this.text = text;
    this.words = text.trim().split(/\s+/) || [];
    this.textPositions = [];
    this.lineHeight = 0;

    // Create separate display objects for each word in the input text
    this.texts = this.words.map((word) => {
      positionHelperText.text += ` ${word}`;

      const t = new Text(this.app, word);
      t.updateStyle(model, options);
      t.lineControls.y = 0;
      t.lineControls.x =
        positionHelperText.lineControls.width - t.lineControls.width;

      this.textPositions.push(t.lineControls.x); // Keep these positions in case we need them for animations

      return t;
    });

    if (this.texts.length) {
      // Since initial style for each word is the same, line height is also the same
      this.lineHeight = this.texts[0].lineControls.height;
      this.addChild(...this.texts);
    }
  }

  /**
   * Apply the callback to each word in the text line
   */
  forEachWord(callback) {
    this.texts.forEach((text, index) =>
      callback(text, {
        index,
        word: this.words[index],
        xPosition: this.textPositions[index],
      })
    );
  }
}
